import { PinOffIcon } from './PinOffIcon';

/**
 * author: Austin Andrews
 * id 8C59FE68-D89C-4A86-8E01-5C8109D1B028
 * name pin-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pin-off.svg
 * tags
 */
export const KeepOffIcon = PinOffIcon;
export default KeepOffIcon